<h1 class="title" mat-dialog-title><mat-icon class="success-icon">check_circle</mat-icon>Form Upload Complete</h1>
<div mat-dialog-content>
  <p class="description">{{data}}</p>
</div>
<div mat-dialog-actions class="footer">
  <button class="close-button" mat-raised-button (click)="onOkClick()">Ok, got it</button>
</div>
